export default __webpack_public_path__ + "static/media/leap.9e2ab6b2.png";